import { get, writable, derived } from "svelte/store";
import "../scripts/utils";
import { addError, addLog, addSystemMsg, addWarn } from "./LoggerStore";
import Path from "../scripts/Path";
import { Node, FileToString, StringToFile, } from "../scripts/FileTypes";
const defaultHome = () => {
    return {
        node: new Node(new Path("~/"), "dir"),
        dirs: [],
        files: [],
    };
};
export class FileMgr {
    constructor() {
        this._home = Object.assign({}, defaultHome());
        this.loaded = writable(false);
        this.dirs = writable([]);
        this.files = writable([]);
        this.initialize();
    }
    get home() {
        return this.findDirReadable(new Path("~/"));
    }
    stringify() {
        return JSON.stringify({
            dirs: get(this.dirs).map((dir) => dir.node.path.path),
            files: get(this.files).map((file) => FileToString(file)),
        });
    }
    setLoading() {
        this.loaded.set(false);
    }
    setLoaded() {
        this.loaded.set(true);
    }
    loadFromString(str) {
        const verify = () => {
            return true;
        };
        if (!verify()) {
            return;
        }
        addSystemMsg("Initializing file system...");
        this.setLoading();
        this.files.update((files) => []);
        this.dirs.update((dirs) => [Object.assign({}, defaultHome())]);
        this._home = Object.assign({}, defaultHome());
        const parsed = JSON.parse(str);
        if (0) {
            console.log(defaultHome());
            console.log("Dirs : ", get(this.dirs));
            const homedir = this.findDirReadable(new Path("~/"));
            console.log("homedir : ", get(homedir));
        }
        //init files
        parsed.files.forEach((file) => this.addFile(StringToFile(file)));
        //make dirs
        parsed.dirs.forEach((dir) => this.mkdir(new Path(dir)));
        addSystemMsg("File system initialized");
        this.setLoaded();
    }
    static getInstance() {
        if (!FileMgr.instance) {
            FileMgr.instance = new FileMgr();
        }
        return FileMgr.instance;
    }
    reset() {
        this.initialize();
    }
    initialize() {
        get(this.files).forEach((file) => this.rm(file.node.path));
        get(this.dirs).forEach((dir) => this.rmdir(dir.node.path));
        this.dirs.set([this._home]);
        this.setLoaded();
    }
    loadFrom(load) {
        //
    }
    ls(dirPath) {
        return this.findDirReadable(dirPath);
    }
    lsValue(dirPath) {
        return get(this.ls(dirPath));
    }
    verifyPath(path) {
        if (!path.path.startsWith(this._home.node.path.path)) {
            throw new Error(`Path does not begin with ${this._home.node.path.path}`);
            return false;
        }
        return true;
    }
    //will update on component view
    findDirReadable(path) {
        const dir = derived(this.dirs, (_dirs) => _dirs.find((dir) => dir.node.path.isSame(path)));
        if (get(dir)) {
            return dir;
        }
        return undefined;
    }
    findFileReadable(path) {
        const file = derived(this.files, (_files) => _files.find((file) => file.node.path.isSame(path)));
        if (get(file)) {
            return file;
        }
        return undefined;
    }
    //not update on component view
    findDirValue(path) {
        if (path.isEmpty) {
            return undefined;
        }
        return get(this.dirs).find((dir) => dir.node.path.isSame(path));
    }
    findFile(path) {
        return get(this.files).find((file) => file.node.path.isSame(path));
    }
    mkdir(path) {
        if (!this.verifyPath(path)) {
            return false;
        }
        //Directory already exists
        if (this.findDirValue(path)) {
            return true;
        }
        const parentPath = new Path(path.parent);
        if (!this.findDirValue(parentPath)) {
            //add parent directory recursively
            this.mkdir(parentPath);
            // addLog(`Missing parent dir : ${parentPath.path}`);
        }
        //find again for updated store
        const newDir = {
            node: new Node(path, "dir"),
            dirs: [],
            files: [],
        };
        this.findDirValue(parentPath).dirs.push(newDir);
        this.updateDir(newDir);
        return true;
    }
    updateDir(dir) {
        return this.dirs.update((dirs) => [
            ...dirs.filter((_dir) => !_dir.node.isSame(dir.node)),
            dir,
        ]);
    }
    updateFile(file) {
        return this.files.update((files) => [
            ...files.filter((_file) => !_file.node.isSame(file.node)),
            file,
        ]);
    }
    mv(from, to) {
        if (!this.findFile(from) || this.findFile(to)) {
            // file to be moved does not exist, or destination path already exists
            addError("mv. file to be moved does not exist, or destination path already exists");
            return false;
        }
        if (!this.mkdir(new Path(to.parent))) {
            addError("mv. failed to make a directory at its parent directory : " + to.parent);
            return false;
        }
        const f = Object.assign({}, this.findFile(from));
        this.rm(from);
        f.node.path = to;
        if (!this.addFile(f)) {
            addError("mv. failed to move file");
            return false;
        }
    }
    rm(path) {
        const parentPath = path.parent;
        const dir = this.findDirValue(new Path(parentPath));
        if (!dir || !dir.files.some((file) => file.node.path.isSame(path))) {
            return false;
        }
        dir.files = dir.files.filter((file) => !file.node.path.isSame(path));
        this.updateDir(dir);
        this.files.update((files) => files.filter((file) => !file.node.path.isSame(path)));
        return true;
    }
    rmdir(path) {
        const dir = this.findDirValue(path);
        if (!dir || path.isEmpty || path.isHome) {
            return false;
        }
        dir.files.forEach((file) => this.rm(file.node.path));
        dir.dirs.forEach((dir) => this.rmdir(dir.node.path));
        this.updateDir(dir);
        this.dirs.update((dirs) => dirs.filter((dir) => !dir.node.path.isSame(path)));
        const parent = this.findDirValue(new Path(path.parent));
        parent.dirs = parent.dirs.filter((dir) => !dir.node.path.isSame(path));
        this.updateDir(parent);
        return true;
    }
    static makeFile(path, type, data) {
        const node = new Node(new Path(path), type);
        const file = {
            node: node,
            data: data,
        };
        return file;
    }
    touch(path, type, data) {
        addLog(`Touch ${path}`);
        return this.addFile(FileMgr.makeFile(path, type, data));
    }
    addFile(file) {
        const path = file.node.path;
        if (this.findFile(path)) {
            addWarn(`${path.path} exists`);
            return false;
        }
        const parentPath = new Path(file.node.parent);
        if (!this.mkdir(parentPath)) {
            addError(`Failed mkdir towards ${parentPath.path}`);
            return false;
        }
        const dir = this.findDirValue(parentPath);
        dir.files.push(file);
        this.updateDir(dir);
        this.updateFile(file);
        return true;
    }
    addFiles(files) {
        files.forEach((file) => this.addFile(file));
    }
}
